import { render, staticRenderFns } from "./TicketsRecord.vue?vue&type=template&id=19f8a2ab&scoped=true&"
import script from "./TicketsRecord.vue?vue&type=script&lang=js&"
export * from "./TicketsRecord.vue?vue&type=script&lang=js&"
import style0 from "./TicketsRecord.vue?vue&type=style&index=0&id=19f8a2ab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f8a2ab",
  null
  
)

export default component.exports